export { default as Fiscais } from "./Fiscais"
export { default as FiscaisEditForm } from "./FiscaisEditForm"
export { default as FiscaisCreateForm } from "./FiscaisCreateForm"
export { default as TableFiscais } from "./TableFiscais"
export { default as FiscaisTrash } from "./FiscaisTrash"
export { default as TableFiscaisTrash } from "./TableFiscaisTrash"



// WEBPACK FOOTER //
// ./src/views/fiscais/index.js